import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "audience", "customRecipientsWrapper" ]

  connect() {
    this.toggleCustomRecipients()
  }

  toggleCustomRecipients() {
    if (!this.hasCustomRecipientsWrapperTarget || !this.hasAudienceTarget) return

    const showCustom = this.audienceTarget.value === "custom"
    this.customRecipientsWrapperTarget.classList.toggle("hidden", !showCustom)
  }
}
